export default __webpack_public_path__ + "static/media/Aura-Egg__64.43b9d29d.png";